import React from "react";
import { Row, Col, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from "recharts";
import OrganizationStatsChart from "../../../Components/common/OrganizationStatsChart";
import RegisterChart from "../../../Components/common/RegisterChart";
import ActivityChart from "../../../Components/common/ActivityChart";
import CustomCarousel from "../../../Components/common/CustomCarousel";
import { FilterIcon, NoDataMessage, LoadingMessage } from "../DashboardMessages";


export const LearnerParentView = (props) => {
  const {
    isLoading, showOrganisationDashboardError, staffStatsData,
    organisationDashboardSharedVideoPerSchoolStatus,
    organisationDashboardSharedVideoPerSchool, fallbackThumb,
    organisationDashboardCategoryPerSchool, usageHoursData, hasUsageHoursData,
    activityData, hasActivityData, registerData, userData, categoryData,
    trendingTags, setSortTags, sortTags, videoData, sortBy, setSortBy,
    recentClasses, totalClassesCount, setSortClasses, sortClasses, sortClassOptions,
    sortOrder, setSortOrder, recentCollections, totalCollectionsCount, sortCollectionOptions,
    setSortCollections, sortCollections, recentStaff, totalStaffCount,
    activeRole, isDateFilter, formatLastActive, navigate, Encryptedid, groupData
  } = props;

  return (
          <>
            <Row className="mb-3 align-items-stretch">
              <Col xxl={7} lg={12} xl={7} className="mt-4 d-flex flex-column">
                <div className="cmn-card-color h-100 d-flex flex-column">
                  <div className="details-chart h-100 d-flex flex-column">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>
                        {`Number of ${activeRole === "Learners" ? "Learner" : "Parent"} Accounts`}
                      </h2>
                    </div>
                    <div className="m-2 flex-grow-1 d-flex flex-column justify-content-between">
                      {isLoading ? (
                        <LoadingMessage />
                      ) : showOrganisationDashboardError ? (
                        <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                      ) : registerData?.length > 0 ? (
                        <RegisterChart
                          registerData={registerData}
                          userData={userData}
                        />
                      ) : (
                        <NoDataMessage />
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={5} lg={12} xl={5} className="mt-4 d-flex flex-column">
                <div className="cmn-card-color h-100 d-flex flex-column">
                  <div className="table-box-cmn h-100 flex-grow-1 d-flex flex-column">
                    <div className="results-sec flex-grow-1 d-flex flex-column">
                      <Row className="flex-grow-1">
                        <Col lg={12} className="most-viewed-categories h-100 d-flex flex-column">
                          <div className="h-100 d-flex flex-column">
                            <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>Most Viewed Categories</h2>
                            <div className="Review-history mt-3 d-flex flex-column justify-content-start" style={{ gap: "14px" }}>
                              {isLoading ? (
                                <LoadingMessage />
                              ) : showOrganisationDashboardError ? (
                                <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                              ) : categoryData.length > 0 ? (
                                <>
                                  {categoryData.map((ele, index) => (
                                    <Row
                                      className="mb-2"
                                      key={`${ele.title}-${index}`}
                                    >
                                      <Col lg={8}>
                                        <div className="d-flex align-items-center gap-3">
                                          <img
                                            src={ele.image || fallbackThumb}
                                            alt="Dashboard visual"
                                          />
                                          <h3>{ele.title}</h3>
                                        </div>
                                      </Col>

                                      <Col className="d-flex align-items-center justify-content-end">
                                        <p>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="12"
                                            viewBox="0 0 18 12"
                                            fill="none"
                                          >
                                            <path
                                              d="M0.328405 5.07509C0.421391 4.96018 0.5212 4.85 0.617859 4.73792C1.87019 3.28616 3.28282 2.03596 4.95665 1.11952C5.92605 0.588744 6.94797 0.21144 8.04075 0.0627858C9.35523 -0.116013 10.6217 0.0958101 11.8502 0.586899C13.3465 1.18502 14.6589 2.08869 15.8295 3.20256C16.4743 3.81612 17.0693 4.48718 17.6628 5.15491C18.1081 5.65603 18.1067 6.31341 17.6921 6.82043C16.5094 8.26679 15.1722 9.5348 13.6004 10.5264C12.5788 11.1709 11.4936 11.6531 10.3068 11.8745C8.85378 12.1456 7.4461 11.97 6.079 11.42C4.45927 10.7684 3.07035 9.74829 1.82024 8.52419C1.294 8.00889 0.803656 7.4532 0.318565 6.89597C0.294028 6.8678 0.271153 6.83811 0.249547 6.80724C-0.115966 6.28515 -0.0717478 5.56964 0.328405 5.07509ZM8.96527 9.99372C11.1136 9.99566 12.8471 8.21568 12.8492 6.00562C12.8513 3.79623 11.1193 2.01122 8.97235 2.01023C6.82384 2.00924 5.08953 3.79021 5.08869 5.99837C5.08786 8.20942 6.81724 9.99174 8.96527 9.99372Z"
                                              fill="#A3AED0"
                                            />
                                            <path
                                              d="M8.96488 8.86177C7.42934 8.86082 6.1855 7.57373 6.18843 5.98888C6.19136 4.42086 7.44391 3.13975 8.97288 3.14097C10.5075 3.14223 11.7531 4.43157 11.7495 6.01516C11.7458 7.58493 10.4959 8.86271 8.96488 8.86177Z"
                                              fill="#A3AED0"
                                            />
                                          </svg>{" "}
                                          {ele.views} Views
                                        </p>
                                      </Col>
                                    </Row>
                                  ))}
                                </>
                              ) : (
                                <NoDataMessage />
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 align-items-stretch">
              <Col xxl={5} lg={5} className="mt-2 display-table">
                <div className="table-cell shadow-sm d-flex flex-column mb-3" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>User Activity</h2>
                  <div className="total-views-chat mt-4 flex-grow-1">
                    {isLoading ? (
                      <LoadingMessage />
                    ) : showOrganisationDashboardError ? (
                      <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                    ) : hasActivityData ? (
                      <ActivityChart activityData={activityData} />
                    ) : (
                      <NoDataMessage />
                    )}
                  </div>
                </div>

                <div className="table-cell shadow-sm d-flex flex-column h-100" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <div className="dash-drop-ad px-0 mb-4">
                    <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>Trending Tags</h2>
                    {trendingTags.length > 0 && (
                      <Dropdown onSelect={setSortTags}>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                        >
                          <FilterIcon />
                          <p className="m-0">
                            {sortTags.charAt(0).toUpperCase() +
                              sortTags.slice(1)}
                          </p>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            eventKey="views"
                            active={sortTags === "views"}
                          >
                            Views
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="likes"
                            active={sortTags === "likes"}
                          >
                            Likes
                          </Dropdown.Item>
                          <Dropdown.Item
                            eventKey="saves"
                            active={sortTags === "saves"}
                          >
                            Saves
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                  {isLoading ? (
                    <LoadingMessage />
                  ) : showOrganisationDashboardError ? (
                    <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                  ) : trendingTags.length > 0 ? (
                    <div className="trending-tags-wrapper mt-2">
                      {trendingTags.map(({ _id, title }) => (
                        <OverlayTrigger
                          key={_id}
                          placement="top"
                          overlay={
                            <Tooltip
                              id={`tooltip-${_id}`}
                              className="tooltip"
                            >
                              Browse {title} Videos
                            </Tooltip>
                          }
                        >
                          <div
                            className="trending-tag-badge"
                            onClick={() =>
                              navigate && navigate(`/browse?searchkey=${title}`)
                            }
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                navigate && navigate(`/browse?searchkey=${title}`);
                              }
                            }}
                          >
                            <span className="tag-title">
                              {title ? `#${title}` : ""}
                            </span>
                          </div>
                        </OverlayTrigger>
                      ))}
                    </div>
                  ) : (
                    <NoDataMessage />
                  )}
                </div>
              </Col>

              <Col xxl={7} lg={7} className="mt-2 display-table">
                <div className="table-cell shadow-sm d-flex flex-column h-100" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <div className="dash-drop-ad mb-4 px-0">
                    <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "24px" }}>Most popular shared videos</h2>
                    <Dropdown onSelect={setSortBy}>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                      >
                        <FilterIcon />{" "}
                        <p className="m-0">
                          {sortBy.charAt(0).toUpperCase() +
                            sortBy.slice(1)}
                        </p>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          eventKey="views"
                          active={sortBy === "views"}
                        >
                          Views
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="likes"
                          active={sortBy === "likes"}
                        >
                          Likes
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="saves"
                          active={sortBy === "saves"}
                        >
                          Saves
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="Review-history mt-3 flex-grow-1 h-100">
                    {isLoading ? (
                      <LoadingMessage style={{ height: "704px" }} />
                    ) : showOrganisationDashboardError ? (
                      <LoadingMessage message="We couldn't load organisation dashboard data right now." />
                    ) : videoData.length > 0 ? (
                      <CustomCarousel
                        videoData={videoData}
                        type="Staff"
                        redirection={true}
                      />
                    ) : (
                      <NoDataMessage style={{ minHeight: "704px" }} />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </>

  );
};
